import * as actions from './reports.actions';
import { ReportsFilter, ReportsOptions, ReportsAvailability } from './reports.models';
import { DatesInterval } from '../../global/interfaces';

export interface State {
  loading: boolean;
  options?: ReportsOptions;
  filter?: ReportsFilter;
  dates?: DatesInterval;
  availability?: ReportsAvailability[];
  visited: boolean;
}

export const initialState: State = {
  loading: false,
  visited: false,
  filter: {
    year: undefined,
    month: undefined
  }
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOAD_REPORTS_DATES:
      return { ...state, loading: true, dates: undefined, filter: { ...initialState.filter } };
    case actions.ActionTypes.LOAD_REPORTS_DATES_SUCCESS:
      return { ...state, loading: false, dates: action.payload };
    case actions.ActionTypes.LOAD_REPORTS_DATES_FAILED:
      return { ...state, loading: false, dates: undefined };

    case actions.ActionTypes.LOAD_REPORTS_AVAILABILITY:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_REPORTS_AVAILABILITY_SUCCESS:
      return { ...state, loading: false, availability: action.payload };
    case actions.ActionTypes.LOAD_REPORTS_AVAILABILITY_FAILED:
      return { ...state, loading: false };

    case actions.ActionTypes.SET_CHECKBOX_OPTIONS:
      return { ...state, options: action.payload };

    case actions.ActionTypes.SET_YEAR_FILTER:
      return { ...state, filter: { ...state.filter, year: action.payload } };
    case actions.ActionTypes.SET_MONTH_FILTER:
      return { ...state, filter: { ...state.filter, month: action.payload } };

    case actions.ActionTypes.SET_REPORTS_VISIT:
      return { ...state, visited: true };

    case actions.ActionTypes.RESET_REPORTS_DATA:
      return { ...initialState };

    default:
      return state;
  }
}
